<template>
  <svg class="icon-arrow-left" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 21L7 12L16 3" stroke="#2350AC" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</template>
